import { dividirPalabras } from "../../helpers/dividirPalabras";

export const useTextSpeech = () => {

    const synth  = window.speechSynthesis;
    let speech;

    if(synth) {
        speech = new SpeechSynthesisUtterance();
        speech.voice = synth.getVoices()[66];
        speech.rate = 0.8;
        speech.volume = 1;
    }
   
    const speak = (module, turn) => {
        const newTurn = dividirPalabras(turn);
        speech.text = newTurn.toUpperCase() + module.toUpperCase();
        window.speechSynthesis.speak(speech);
    }

    return {
        synth,
        speak
    }
};